import { getPersistedFilterKey } from "modules/common/hooks/usePersistedFilters";
import { AMOUNT_FILTER_KEYS } from "modules/common/types/filters";
import { createAmountFilterSchema } from "modules/common/utils/amountFilterSchema";
import { getLastMonthDateRange } from "modules/common/utils/getLastMonthDateRange";
import { object } from "utils/yup";

import type { DefaultFilterConfiguration } from "modules/common/hooks/useGetUrlFilters";

import type { PaymentsFilters } from "../models/PaymentsFilters";

const { start, end } = getLastMonthDateRange();

export const FILTERS_KEYS = {
  ...AMOUNT_FILTER_KEYS,
  STATUS: "status",
  OPERATION: "operation",
  TYPE: "type",
  END_DATE: "endDate",
  START_DATE: "startDate",
  CURRENCY: "currency",
  CUSTOMER: "customer",
  ACCOUNT: "account",
} as const;

export const DEFAULT_FILTERS = {
  [FILTERS_KEYS.START_DATE]: start.toISODate(),
  [FILTERS_KEYS.END_DATE]: end.toISODate(),
  [FILTERS_KEYS.TYPE]: [],
  [FILTERS_KEYS.STATUS]: [],
  [FILTERS_KEYS.CURRENCY]: [],
  [FILTERS_KEYS.CUSTOMER]: [],
  [FILTERS_KEYS.ACCOUNT]: [],
  [FILTERS_KEYS.AMOUNT_FROM]: null,
  [FILTERS_KEYS.AMOUNT_TO]: null,
} as const satisfies PaymentsFilters;

export const DEFAULT_FILTERS_CONFIGURATION = {
  [FILTERS_KEYS.START_DATE]: {
    array: false,
    defaultValue: null,
  },
  [FILTERS_KEYS.END_DATE]: {
    array: false,
    defaultValue: null,
  },
  [FILTERS_KEYS.TYPE]: {
    array: true as const,
    defaultValue: [],
  },
  [FILTERS_KEYS.CURRENCY]: {
    array: true as const,
    defaultValue: [],
  },
  [FILTERS_KEYS.CUSTOMER]: {
    array: true as const,
    defaultValue: [],
  },
  [FILTERS_KEYS.ACCOUNT]: {
    array: true as const,
    defaultValue: [],
  },
  [FILTERS_KEYS.STATUS]: {
    array: true as const,
    defaultValue: [],
  },
  [FILTERS_KEYS.AMOUNT_FROM]: {
    array: false,
    defaultValue: null,
  },
  [FILTERS_KEYS.AMOUNT_TO]: {
    array: false,
    defaultValue: null,
  },
} as const satisfies DefaultFilterConfiguration<PaymentsFilters>;

export const FILTERS_PERSISTED_KEY = getPersistedFilterKey(
  "volt-accounts.payments"
);

export const FILTERS_SCHEMA = object().shape({
  ...createAmountFilterSchema(),
});
